/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { FilledButton, Tooltip } from '@neo4j-ndl/react';
import { Reasoning } from '@neo4j-ndl/react/ai';
import {
  InformationCircleIconOutline,
  PencilSquareIconOutline,
  WrenchIconOutline,
} from '@neo4j-ndl/react/icons';
import { useState } from 'react';

const Component = () => {
  const [isThinking, setThinking] = useState(true);

  return (
    <div className="n-flex n-flex-col n-gap-token-12">
      <FilledButton onClick={() => setThinking(!isThinking)}>
        {isThinking ? 'Stop Thinking' : 'Start Thinking'}
      </FilledButton>
      <Reasoning
        isThinking={isThinking}
        thinkingMs={1400}
        currentAction="Creating an action plan"
      >
        <Reasoning.Section
          leadingVisual={<PencilSquareIconOutline />}
          heading="Creating an action plan"
          isDefaultExpanded={true}
        >
          Step 1 content
        </Reasoning.Section>
        <Reasoning.Section
          leadingVisual={<WrenchIconOutline />}
          heading="Applying agent tools"
        >
          Step 2 content
        </Reasoning.Section>
        <Reasoning.Footer>
          Footer information
          <Tooltip type="simple">
            <Tooltip.Trigger
              htmlAttributes={{ 'aria-label': 'Info about things like tokens' }}
            >
              <InformationCircleIconOutline className="n-size-token-16" />
            </Tooltip.Trigger>
            <Tooltip.Content>Info about things like tokens</Tooltip.Content>
          </Tooltip>
        </Reasoning.Footer>
      </Reasoning>
    </div>
  );
};

export default Component;
